import React from "react";
import "./NotFound.scss";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound: React.FC = () => {
  return (
    <main className="notFound">
      <Helmet>
        <title>Page Not Found | Alena Lobacheva Photography</title>
        <meta name="prerender-status-code" content="404" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="notFound__card">
        <p className="notFound__eyebrow">The page could not be found</p>
        <h1 className="notFound__title">404</h1>
        <h2 className="notFound__heading">Let&apos;s help you find the right place.</h2>
        <p className="notFound__description">
          The page may have moved or the address may be incorrect. Explore photography sessions and helpful guides, or
          return to the homepage.
        </p>
        <div className="notFound__actions">
          <Link to="/" className="notFound__link notFound__link--primary">
            Return home
          </Link>
          <Link to="/resources/" className="notFound__link">
            Explore guides
          </Link>
          <Link to="/prices/newborn/" className="notFound__link">
            View sessions
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
